<template>
    <div class="TrainingSessionManage">
        <v-card>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-left">Booking ID</th>
                            <th class="text-left">Name</th>
                            <th class="text-left">Email</th>
                            <th class="text-left">Company</th>
                            <th class="text-left">Joining Instructions</th>
                            <th class="text-left">Attended</th>
                            <th class="text-left">Certificate Sent</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="attendee in model.allAttendees" :key="attendee.id">
                            <td>
                                <v-btn
                                        :to="{name: 'booking-view', params: { id: attendee.booking.id }}"
                                        small
                                >
                                    BK-{{ attendee.booking.id }}
                                </v-btn>
                            </td>
                            <td>{{ attendee.firstName }} {{ attendee.lastName }}</td>
                            <td>{{ attendee.email }}</td>
                            <td>{{ attendee.booking.contactCompany }}</td>
                            <td>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <TrueFalseIcon
                                    :value="attendee.joiningInstructionsSentAt !== null"
                                    v-bind="attrs"
                                    v-on="on"
                                  />

                                </template>
                                <span>{{ attendee.joiningInstructionsSentAt }}</span>
                              </v-tooltip>

                            </td>
                            <td><TrueFalseIcon :value="attendee.attended"/></td>
                            <td>
                              <div class="d-flex flex-row">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <TrueFalseIcon
                                      :value="attendee.certificateSentAt !== null"
                                      v-bind="attrs"
                                      v-on="on"
                                    />

                                  </template>
                                  <span>{{ attendee.certificateSentAt }}</span>
                                </v-tooltip>
                                <v-btn :href="attendee.certificateUrl" text x-small color="red">
                                  <v-icon>fa-solid fa-file-pdf</v-icon>
                                </v-btn>
                              </div>

                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>


    </div>
</template>
<script>
    import TrueFalseIcon from "../TrueFalseIcon";
    export default {
        props: {
            model: Object,
        },
      components: {TrueFalseIcon}
    };
</script>
